import script from "./UploadFileDrag.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFileDrag.vue?vue&type=script&setup=true&lang=js"

import "./UploadFileDrag.vue?vue&type=style&index=0&id=5142e2eb&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5142e2eb"]])

export default __exports__